// Copyright 2023, Common Good Learning Tools LLC
import { mapState, mapGetters } from 'vuex'

export default {
	methods: {
		view_resource_set(resource_set_id, $event, functionality_version) {
			// resources/37
			let url = '/resources/' + resource_set_id

			// if user holds meta/ctrl key down, open in a new tab/window
			if (U.meta_or_alt_key($event)) {
				window.open(url)
			} else {
				this.$router.push({ path: url })
			}
		},
	}
}